import * as React from "react"

import TagManager from "../../services/tagManager"
import { SendEmailApi, VerifyReCaptchaApi } from "../../../api/services"
import { getAzureApiManagementClient } from "../../../api/clients"
import {
  ContactFormActionType,
  ContactFormResultType,
} from "../../../common/enums"
import DispatchMiddlewareHelper from "./middleware-helpers"

const client = getAzureApiManagementClient()
const sendEmailApi = new SendEmailApi(client)
const verifyReCaptchaApi = new VerifyReCaptchaApi(client)

/**
 * Middleware for dispatch which performs async operations, if and
 * when required, and then calls the actual dispatch with the results.
 *
 * @param dispatch - the dispatch function
 */
const dispatchMiddleware = (
  dispatch: React.Dispatch<any>,
  tagManager: TagManager | null
) => {
  return async (action: any) => {
    const helper = new DispatchMiddlewareHelper(dispatch)

    switch (action.type) {
      case ContactFormActionType.SendEmail: {
        helper.setIsLoading(true)
        helper.setModalState("waiting")
        helper.setIsModalOpen(true)
        try {
          await sendEmailApi.execute(action.payload)
          tagManager?.onFormSubmissionEvent({
            lead_type: "contact_us_subscription",
          })
          helper.setModalState("success")
          dispatch({ type: ContactFormResultType.ResetDataSubject })
          dispatch({ type: ContactFormResultType.ResetDataMessage })
          dispatch({
            type: ContactFormResultType.SetSubmitted,
            payload: { isSubmitted: true },
          })
          helper.setIsLoading(false)
        } catch (error) {
          helper.setModalState("failed")
          helper.setIsLoading(false)
        }
        break
      }

      case ContactFormActionType.VerifyReCaptcha: {
        helper.setIsLoading(true)
        try {
          const response = await verifyReCaptchaApi.execute({
            token: action.payload.captchaToken,
          })
          if (response.data.success) {
            dispatch({
              type: ContactFormResultType.SetVerified,
              payload: { isVerified: true },
            })
          } else {
            dispatch({
              type: ContactFormResultType.SetCaptchaToken,
              payload: { captchaToken: null },
            })
            helper.setModalState("captcha_failed")
            helper.setIsModalOpen(true)
          }
          helper.setIsLoading(false)
        } catch (error) {
          dispatch({
            type: ContactFormResultType.SetCaptchaToken,
            payload: { captchaToken: null },
          })
          helper.setModalState("captcha_failed")
          helper.setIsModalOpen(true)
          helper.setIsLoading(false)
        }
        break
      }

      default:
        return dispatch(action)
    }
  }
}

export default dispatchMiddleware
